declare const VERSION: string;
declare const BUILD_TIME: string;
declare const NAME: string;

export const version = VERSION;
export const buildTime = BUILD_TIME;
export const name = NAME;
